import { render, staticRenderFns } from "./Estados.vue?vue&type=template&id=9203dea2"
import script from "./Estados.vue?vue&type=script&lang=js"
export * from "./Estados.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports